import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({

    events: {
      "change .js-dateFilter": "searchCommande"
    },

    initialize: function () {
      var pageIndex = this.urlParam('pageIndex');
      var pageSize = this.urlParam('pageSize');
      var dateFilter = this.urlParam('dateFilter');
      var command = this.urlParam('command');

      if (command == '0') {
        command = '';
      }

      $('#pageIndex').val(pageIndex);
      $('#pageSize').val(pageSize);
      $('#dateFilter').val(dateFilter);
      $('#command').val(command);
      $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
          return null;
        }
        else {
          return decodeURI(results[1]) || 0;
        }
      }
    },

    searchCommande: function (e) {
      $('#pageIndex').val("1");
      $("#yearFilterForm").submit();
    },

    urlParam: function (name) {
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results == null) {
        return null;
      }
      else {
        return decodeURI(results[1]) || 0;
      }
    }

  })
